<template>
  <div class="dashboard">       
    <Sidebar/>
    <div class="page">
      <!-- <Toolbar /> -->
      <div class="content dashboard superAdmin">
        <div class="container container-super-admin">
          <div class="container-inner" v-if="hasReady">
            <!-- Seção: Informações da Empresa -->
            <div class="section-title">
              <h4>Informações da Empresa</h4>
              <p>Preencha os dados básicos da empresa</p>
            </div>
            <div class="row">
              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Razão Social<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="tradeName"
                      placeholder="Digite a razão social"
                    />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Nome Fantasia<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="name"
                      placeholder="Digite o nome fantasia"
                    />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CNPJ<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="idFiscal"
                      placeholder="Digite o CNPJ"
                      v-mask="'##.###.###/####-##'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>E-mail<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="email"
                      placeholder="Digite o e-mail"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Telefone<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="phone"
                      placeholder="Digite o telefone"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                </div>
             </div>

             <!-- Seção: Endereço -->
             <div class="col-form-inner col-12 col-md-12 col-lg-12">
               <div class="section-title">
                 <h4>Endereço</h4>
                 <p>Informe o endereço completo da empresa</p>
               </div>
             </div>
             <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>CEP<v-tooltip text="Informe o CEP" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00000-000"
                      v-model="postcode"
                      v-mask="'#####-###'"
                      @input="getCep"
                    />
                  </div>
                </div>
              </div>

               
              <!-- <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="col-form-inner col-12 col-md-12 col-lg-12 cep">
                  <div class="form-group actions">
                    <button class="btn">
                      Pesquisar
                    </button>
                  </div>
                </div>
              </div>
 -->

              <div class="col-form-inner col-8 col-md-8 col-lg-8">
                <div class="form-group">
                  <div class="form-label">
                    <label>Endereço</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o endereço"
                      v-model="address"
                    />
                  </div>
                </div>
              </div>



              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Número<v-tooltip text="Informe o número" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Número"
                      v-model="addressNumber"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Complemento<v-tooltip text="Informe o complemento" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Complemento"
                      v-model="addressComplement"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Bairro</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o bairro"
                      v-model="neighborhood"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Cidade</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite a cidade"
                      v-model="city"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Estado</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o estado"
                      v-model="county"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>País</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Digite o país"
                      v-model="country"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Configurações do Sistema -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <h4>Configurações do Sistema</h4>
                  <p>Defina as configurações básicas do sistema</p>
                </div>
              </div>
              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Tipo de Sistema<v-tooltip text="Selecione o estado" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="typeSystem"
                    >
                      <option value="" disabled selected>Selecione o tipo</option>
                      <option value="1">Weeduc</option>
                      <option value="2">Weflix</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Plano de Teste</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model="testPlan"
                      placeholder="Digite o plano de teste"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Status do Carrinho</label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="cartStatus"
                    >
                      <option value="" disabled selected>Selecione o status</option>
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Cor da Empresa<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="inputsColors">
                    <input type="color" id="body" name="body" v-model="color" />
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="color"
                      placeholder="#ffffff"
                    />
                  </div>
                </div>
              </div>
<!-- 
            <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Logo</label>
                    <small>Insira uma imagem maior que 250x250 pixels</small>
                  </div>
                  <div class="form-file">
                    <div class="file-wrapper primary">
                      <img
                      :src="logoPreview? logoPreview : logo"
                      alt="Logo"
                      v-show="logoPreview || logo"
                      style="width: 250px;"
                    />
                      <span class="thumbnail">
                        <span class="icon">
                          <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></path>
                            <rect
                              x="1.00049"
                              y="1.40454"
                              width="43.9461"
                              height="36.1909"
                              rx="2.58507"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></rect>
                            <circle
                              cx="14.8948"
                              cy="10.6676"
                              r="3.71629"
                              stroke="#9D9FA3"
                              stroke-width="1.25714"
                            ></circle>
                          </svg>
                        </span>
                        <span class="text">
                          Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                      </span>
                      <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathLogo"
                        accept=".png, .jpg, .jpeg, .webp"
                      />
                    </div>
                  </div>
                </div>
            </div> -->

            <!-- <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                    <div class="form-label">
                    <label>Favicon</label>
                    <small>Insira uma imagem maior que 250x250 pixels</small>
                    </div>
                    <div class="form-file">
                    <div class="file-wrapper primary">
                        <img
                        :src="faviconPreview? faviconPreview : favicon"
                        alt="Favicon"
                        v-show="faviconPreview || favicon"
                        style="width: 250px;"
                    />
                        <span class="thumbnail">
                        <span class="icon">
                            <svg
                            width="46"
                            height="39"
                            viewBox="0 0 46 39"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></path>
                            <rect
                                x="1.00049"
                                y="1.40454"
                                width="43.9461"
                                height="36.1909"
                                rx="2.58507"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></rect>
                            <circle
                                cx="14.8948"
                                cy="10.6676"
                                r="3.71629"
                                stroke="#9D9FA3"
                                stroke-width="1.25714"
                            ></circle>
                            </svg>
                        </span>
                        <span class="text">
                            Clique aqui para selecionar a imagem
                        </span>
                        <LoaderImage :hasReady="loaderImage"/>
                        </span>
                        <input
                        class="form-control"
                        type="file"
                        @change="updateFilePathFavicon"
                        accept=".png, .jpg, .jpeg, .webp"
                        />
                    </div>
                    </div>
                </div>
                </div> -->


                <!-- <div class="col-form-inner col-4 col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="form-label">
                      <label>Tema<v-tooltip text="Selecione o tema" location="top">
                        <template v-slot:activator="{ props }">
                          <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                        </template>
                      </v-tooltip></label>
                    </div>
                    <div class="form-input">
                      <select
                        class="form-control"
                        v-model="theme"
                      >
                        <option value="dark">Dark</option>
                        <option value="light">Light</option>
                      </select>
                      <small class="small">
                          Selecione o tema da interface do sistema.
                      </small>
                    </div>
                  </div>
                </div> -->

                <div class="col-form-inner col-4 col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="form-label">
                        <label>Tempo de Vídeo<v-tooltip text="Selecione o estado" location="top">
                          <template v-slot:activator="{ props }">
                            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                          </template>
                        </v-tooltip></label>
                      </div>
                      <div class="form-input">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Nome do bairro"
                          v-model="videoTimeTotal"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Seção: Configurações de Pagamento -->
                  <div class="col-form-inner col-12 col-md-12 col-lg-12">
                    <div class="section-title">
                      <h4>Configurações de Pagamento</h4>
                      <p>Configure as informações bancárias e de split</p>
                    </div>
                  </div>
                  <div class="col-form-inner col-3 col-md-3 col-lg-3">
                    <div class="form-group">
                      <div class="form-label">
                        <label>Habilitar Split</label>
                      </div>
                      <div class="form-input">
                        <select
                          class="form-control"
                          v-model="split"
                        >
                          <option value="" disabled selected>Selecione o status</option>
                          <option value="1">Ativo</option>
                          <option value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
              </div>


              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Banco</label>
                  </div>
                  <div class="form-input">
                    <select
                      required
                      class="form-control"
                      v-model="bank"
                    >
                      <option value="" disabled selected>Selecione o banco</option>
                      <option value="001">001 - BANCO DO BRASIL S.A.</option>
                      <option value="033">033 - BANCO SANTANDER S.A.</option>
                      <option value="104">104 - CAIXA ECONÔMICA FEDERAL</option>
                      <option value="237">237 - BANCO BRADESCO S.A.</option>
                      <option value="341">341 - BANCO ITAÚ S.A.</option>
                      <option value="077">077 - BANCO INTER S.A.</option>
                      <option value="260">260 - NUBANK</option>
                      <option value="336">336 - BANCO C6 S.A.</option>
                      <option value="290">290 - PAGSEGURO INTERNET S.A.</option>
                      <option value="380">380 - PICPAY</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Agência</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="branch"
                      placeholder="Número da agência"
                      v-mask="'####'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Agência</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="digitBranch"
                      placeholder="Dígito"
                      v-mask="'#'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Conta</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="account"
                      placeholder="Número da conta"
                      v-mask="'#######'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Conta</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="digitAccount"
                      placeholder="Dígito"
                      v-mask="'#'"
                    />
                  </div>
                </div>
              </div>

    <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Valor por transação (R$)<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="transactionValue"
              placeholder="1,00"
            />
          </div>
        </div>
    </div>




    <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Percentual do Cliente (%)<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="percentualClient"
              placeholder="10"
            />
          </div>
        </div>
    </div>

    <!-- Seção: Informações do Responsável -->
    <div class="col-form-inner col-12 col-md-12 col-lg-12">
      <div class="section-title">
        <h4>Informações do Responsável</h4>
        <p>Preencha os dados do responsável pela empresa</p>
      </div>
    </div>
    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Nome do Responsável<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="nameRepresentative"
              placeholder="João da Silva"
            />
          </div>
        </div>
    </div>


    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>E-mail do Responsável<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="emailRepresentative"
              placeholder="email@email.com"
            />
          </div>
        </div>
    </div>

      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>CPF do Responsável<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="idRepresentative"
              v-mask="'###.###.###-##'"
              placeholder="000.000.000-00"
            />
          </div>
        </div>
    </div>



      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Data de Nascimento<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="date" 
              required
              class="form-control"
              v-model="birthdate"
              placeholder="00/00/0000"
            />
          </div>
        </div>
    </div>



      <div class="col-form-inner col-4 col-md-4 col-lg-4">
        <div class="form-group">
          <div class="form-label">
            <label>Profissão do Responsável<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="professional_occupation"
              placeholder="Engenheiro"
            />
          </div>
        </div>
    </div>

    <!-- <hr> -->

    <!-- <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>Título<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="title"
                    placeholder="Meu Site"
                />
                <small>Digite o título do seu site.</small>
                </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Tipo do Layout<v-tooltip text="Selecione o estado" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input">
                <select
                class="form-control"
                v-model="typeLayout"
                >
                <option value="" disabled selected>Selecione o tipo</option>
                <option value="1">Clean</option>
                <option value="2">Dark</option>
                </select>
                <small class="small">
                Selecione o tipo de sistema 1 - Weeduc e 2 - Weflix.
                </small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Tipo do Layout Portal<v-tooltip text="Selecione o estado" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input">
                <select
                class="form-control"
                v-model="typeLayoutPortal"
                >
                <option value="" disabled selected>Selecione o tipo</option>
                <option value="1">Clean</option>
                <option value="2">Dark</option>
                </select>
                <small class="small">
                Selecione o tipo de sistema 1 - Weeduc e 2 - Weflix.
                </small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>E-mail<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="emailSite"
                    placeholder="exemplo@dominio.com"
                />
                <small>Digite o e-mail do seu site.</small>
                </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="form-label">
                <label>Telefone<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                </v-tooltip></label>
                </div>
                <div class="form-input">
                <input
                    type="text" 
                    required
                    class="form-control"
                    v-model="phoneSite"
                    placeholder="Digite o telefone"
                    v-mask="'(##) #####-####'"
                />
                <small>Digite o telefone do seu site.</small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
            <div class="form-group">
            <div class="form-label">
                <label>Descrição<v-tooltip text="Campo obrigatório" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input"> 
                <textarea v-model="description"></textarea>
                <small>Nome comercial do seu curso, uso externo.</small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12 textarea">
            <div class="form-group">
            <div class="form-label">
                <label>Palavras Chaves<v-tooltip text="Campo obrigatório" location="top">
                <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                </template>
                </v-tooltip></label>
            </div>
            <div class="form-input"> 
                <textarea v-model="keywords"></textarea>
                <small>Nome comercial do seu curso, uso externo.</small>
            </div>
            </div>
        </div>
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
            <div class="form-label">
                <label>Banner Principal</label>
                <small>Insira uma imagem maior que 250x250 pixels</small>
            </div>
            <div class="form-file">
                <div class="file-wrapper primary">
                <img
                :src="pathImagePreview? pathImage : logo"
                alt="Logo"
                v-show="pathImage || logo"
                style="width: 250px;"
                />
                <span class="thumbnail">
                    <span class="icon">
                    <svg
                        width="46"
                        height="39"
                        viewBox="0 0 46 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                        d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></path>
                        <rect
                        x="1.00049"
                        y="1.40454"
                        width="43.9461"
                        height="36.1909"
                        rx="2.58507"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></rect>
                        <circle
                        cx="14.8948"
                        cy="10.6676"
                        r="3.71629"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                        ></circle>
                    </svg>
                    </span>
                    <span class="text">
                    Clique aqui para selecionar a imagem
                    </span>
                    <LoaderImage :hasReady="loaderImage"/>
                </span>
                <input
                    class="form-control"
                    type="file"
                    @change="updateFilePathLogo"
                    accept=".png, .jpg, .jpeg, .webp"
                />
                </div>
            </div>
            </div>
        </div>
    </div> -->


            </div>
            <div class="actionsSave">
              <button class="btnSave btnCancel" @click="$router.push('/admin/empresas')">
                Voltar
              </button>
              <button class="btnSave" @click="createNewCompany">
                Salvar
              </button>
            </div>
          </div> 
        </div>
      </div>
    </div>
    <Loader :hasReady="hasReady"/>  
    <Footer/>
  </div>
</template>

<script>
  import Sidebar from '@/components/Weflix/Sidebar-SuperAdmin.vue'
  import Footer from '@/components/Admin/Footer/footerSuperAdmin.vue'
  import { mapState, mapActions } from 'vuex';
  import ApiCep from '@/utils/cep.js';
  import superAdmin from '@/utils/superAdmin';
  import Loader from '@/components/Weflix/Loader.vue';


  export default {
    data() {
      return {
        tradeName: '',
        bank: '',
        branch: '',
        digitBranch: '',
        account: '',
        split: 0,
        loaderImage: false,
        idFiscal: '',
        county: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        city: '',
        neighborhood: '',
        state: '',
        name: '',
        postcode: '',
        imagePath: '',
        branch: '',
        digitBranch: '',
        account: '',
        videoTimeTotal: '',
        email: '',
        phone: '',
        percentualClient: '',
        transactionValue: '',
        url: '',
        url1: '',
        url2: '',
        typeSystem: 1,
        testPlan: 1,
        cartStatus: 1,
        color: '#00FF00',
        country: 'Brasil',
        emailRepresentative: '',
        nameRepresentative: '',
        professional_occupation: '',
        birthdate: '',
        idRepresentative: '',
        title: '',
        emailSite: '',
        phoneSite: '',
        typeLayout: 0,
        urlTemporary: '',
        hasValidDomain: null,
        hasReady: true
      }
    },
    components: {
      Sidebar,
      Footer,
      Loader
    },
    computed: {
      ...mapState(['token']),
    },
    methods: {
        ...mapActions(['storeCurrentCompanyCreated']),
      async createNewCompany() {
        this.hasReady = false;
        const payload ={
        "company": {
            "idFiscal": this.idFiscal.replace(/[^\d]/g, ''),
            "name": this.name,
            "country": "Brasil", 
            "county": this.county,
            "city": this.city,
            "address": this.address,
            "addressNumber": this.addressNumber,
            "addressComplement": this.addressComplement,
            "postcode": this.postcode.replace(/[^\d]/g, ''),
            "testPlan": this.testPlan,
            "typeSystem": this.typeSystem,
            "anticipation": 1,
            "videoComments": 1,
            "cartStatus": this.cartStatus,
            "intallmentCheckout": 1,
            "color": this.color,
            "country": this.country,
            "imagePath": this.imagePath,
            "imageFinalPath": this.imagePath,
            "bank": "033",
            "branch": this.branch,
            "digitBranch": this.digitBranch,
            "account": this.account,
            "digitAccount": "8",
            "videoTimeTotal": this.videoTimeTotal,
            "videoTimeUsed": 0,
            "idFolderVideoteca": 1001,
            "tradeName": this.tradeName,
            "email": this.email,
            "phone": this.phone.replace(/[^\d]/g, ''),
            "percentualClient": this.percentualClient,
            "transactionValue": this.transactionValue.replace(',','.'),
            "neighborhood": this.neighborhood,
            "split": this.split == "1" ? 1 : 0,
        },
        "representative": {
            "name": this.nameRepresentative,
            "email": this.emailRepresentative,
            "document": this.idRepresentative.replace(/[^\d]/g, ''),
            "birthdate": this.birthdate,
            "professional_occupation": this.professional_occupation
        }
        }
        console.debug(payload);
        try {
          const response = await superAdmin.createCompany(this.token, payload);
          this.hasReady = true;
          this.storeCurrentCompanyCreated({currentCompanyCreated: response});
          this.$router.push('/personalizar-empresa/'+response.company.id);
        } catch (error) {
          console.error(error);
          this.hasReady = true;
        }
      },
    setPageTitle() {
      document.title ='Tutor -Super Admin';
    },
    setFavicon() {
      const favicon = document.querySelector('link[rel="icon"]');
      if (!favicon) {
        const newFavicon = document.createElement('link'); 
        newFavicon.rel = 'icon';
        newFavicon.href = this.imagePath || '/favicon-tutor.ico';
        
        document.head.appendChild(newFavicon);
      } else {
        favicon.href = this.imagePath || '/favicon-tutor.ico';
      }
    },
    async getCep(){
        if(this.postcode.length >= 7){
            try {
                const response = await ApiCep.getDataCep(this.postcode);
                this.county = response.uf;
                this.address = response.logradouro;
                this.addressNumber = response.numero;
                this.addressComplement = response.complemento;
                this.city = response.localidade;
                this.neighborhood = response.bairro;
            } catch (error) {
              
            }
        }
    },

    },
    mounted() {
      this.setPageTitle();
      this.setFavicon();
    }
  }
</script>

<style>
  .flex {
    display: flex;
    align-items: flex-start;
    gap: 0px;
    flex-wrap: wrap;
  }
  .dashboard {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #eef0fc;
    margin: 0;
    position: relative;
  }   
  .content.dashboard {
    background-color: transparent;
    margin: 0;
    width: 100%;
    padding: 10px 10px;
    min-height: 100%;
  }
  .col-form-inner {
    padding: 0px;
}
.form-group {
    margin: 5px 10px;
}
textarea {
    height: 120px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    resize: none;
    outline: none;
    padding: 0.5rem 0.75rem;
    color: #5f5f5f;
    background-color: #fff;
    border: 1px solid #dbdcde;
    box-shadow: none;
    width: 100%;
    border-radius: 5px;
}
button.btn_new {
    color: #250891;
    width: 20%;
    background-color: #ffffff;
    padding: 6px 10px;
    border-radius: 5px;
    transition: all 500ms ease-in-out;
    font-size: 18px;
    border: 1px solid #250891;
}
.content.dashboard.superAdmin {
    margin-bottom: 70px;
}
hr {
    width: 95%;
    margin: 25px auto;
}
span.iconCopy {
    position: absolute;
    top: 10px;
    right: 5px;
    cursor: pointer;
    z-index: 9;
}
svg.svg-inline--fa.fa-check {
    color: green;
}
svg.svg-inline--fa.fa-xmark {
    color: white;
}
.container {
    padding: 10px;
}
.container.container-super-admin {
    width: 84%;
    left: 15.5%;
    position: absolute;
    max-width: 100%;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 40px;
}

.container.container-super-admin .titleContainer {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e8e8e8;
}

.container.container-super-admin .titleContainer .primaryHeader h3 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 8px 0;
    line-height: 1.3;
}

.container.container-super-admin .titleContainer .primaryHeader p {
    font-size: 0.95rem;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
}

.container.container-super-admin .row {
    margin: 0 -10px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.container.container-super-admin .col-form-inner {
    padding: 0 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.container.container-super-admin .col-form-inner.col-2 {
    flex: 0 0 16.666%;
    max-width: 16.666%;
}

.container.container-super-admin .col-form-inner.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

.container.container-super-admin .col-form-inner.col-4 {
    flex: 0 0 33.333%;
    max-width: 33.333%;
}

.container.container-super-admin .col-form-inner.col-6 {
    flex: 0 0 50%;
    max-width: 50%;
}

.container.container-super-admin .col-form-inner.col-8 {
    flex: 0 0 66.666%;
    max-width: 66.666%;
}

.container.container-super-admin .col-form-inner.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}

.container.container-super-admin .form-group {
    margin: 0;
}

.container.container-super-admin .form-label {
    margin-bottom: 8px;
}

.container.container-super-admin .form-label label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
}

.container.container-super-admin .form-label svg {
    color: #9ca3af;
    font-size: 0.75rem;
}

.container.container-super-admin .form-input {
    margin-bottom: 0;
}

.container.container-super-admin .form-control {
    width: 100%;
    padding: 10px 14px;
    font-size: 0.875rem;
    color: #1a1a1a;
    background-color: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.container.container-super-admin .form-control:focus {
    outline: none;
    border-color: #250891;
    box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.1);
}

.container.container-super-admin .form-control:hover {
    border-color: #9ca3af;
}

.container.container-super-admin .form-input small {
    display: block;
    margin-top: 6px;
    font-size: 0.75rem;
    color: #6b7280;
    line-height: 1.4;
}

.container.container-super-admin hr {
    width: 100%;
    margin: 30px 0;
    border: none;
    border-top: 1px solid #e5e7eb;
}

.container.container-super-admin .actionsSave {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e8e8e8;
    position: relative;
}

.container.container-super-admin .btnSave {
    background-color: #250891;
    color: white;
    padding: 12px 32px;
    border: none;
    border-radius: 6px;
    font-size: 0.9375rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(37, 8, 145, 0.2);
}

.container.container-super-admin .btnSave:hover:not(:disabled) {
    background-color: #1f0770;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(37, 8, 145, 0.3);
}

.container.container-super-admin .btnSave:active:not(:disabled) {
    transform: translateY(0);
}

.container.container-super-admin .btnSave:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
}

.container.container-super-admin .btnCancel {
    background-color: #6b7280;
}

.container.container-super-admin .btnCancel:hover:not(:disabled) {
    background-color: #4b5563;
}

.container.container-super-admin .itemAtionCollections {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}

.container.container-super-admin .itemAtionCollections span {
    font-size: 0.875rem;
    color: #374151;
    font-weight: 500;
}

.container.container-super-admin .form-check-input {
    width: 48px;
    height: 24px;
    cursor: pointer;
}

/* Melhorias para select */
.container.container-super-admin select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding: 6px 14px;
    padding-right: 36px;
}

.container.container-super-admin .container-inner {
    padding: 0;
    margin: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
}

.container.container-super-admin .section-title {
    margin: 40px 0 25px 0;
    padding-top: 10px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e8e8e8;
    text-align: left;
}

.container.container-super-admin .section-title:first-of-type {
    margin-top: 0;
}

.container.container-super-admin .section-title h4 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 6px 0;
    line-height: 1.3;
    text-align: left;
}

.container.container-super-admin .section-title p {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
    text-align: left;
}

/* Responsividade */
@media (max-width: 1200px) {
    .container.container-super-admin {
        width: 90%;
        left: 10%;
        padding: 25px;
    }
}

@media (max-width: 768px) {
    .container.container-super-admin {
        width: 100%;
        left: 0;
        padding: 20px;
        margin-top: 10px;
        border-radius: 0;
    }
    
    .container.container-super-admin .col-form-inner {
        margin-bottom: 15px;
    }
    
    .container.container-super-admin .actionsSave {
        margin-top: 30px;
        padding-top: 20px;
        flex-direction: column;
    }
    
    .container.container-super-admin .btnSave {
        width: 100%;
        padding: 14px 32px;
        margin-left: 0 !important;
    }
}
</style>
<style scoped>
@media (max-width: 600px) {
  .col-2 {
    width: 100%;
  }
  .col-3 {
    width: 100%;
  }
  .col-4 {
    width: 100%;
  }
  .col-8 {
    width: 100%;
  }
}
</style>